














































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { SheetActivity, Examinee } from "../../modules/teacher/SheetUpload"


export interface Data {
  sheet_id: string
  sheet: any
  examinees: Examinee[]
  currentExaminee: Examinee | null
  currentSheetActivity: SheetActivity | null
  currentExamineeIdx: number
  currentSheetActivityIdx: number
  errors: string[]
  meiboErrors: string[]
  scale: number
  rotates: number[]
  files: File[]
  progress: string
  isDispProgress: boolean
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  ApiTypeEnum: Readonly<{None: number; Classroom: number; Teams: number}>
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalSheetUploadRef = ref<InstanceType<typeof BModal>>();
    const modalMeiboUploadRef = ref<InstanceType<typeof BModal>>();


    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      sheet_id: "",
      sheet: {score_positions_completed: true},
      examinees: [],
      currentExaminee: null,
      currentSheetActivity: null,
      currentExamineeIdx: 0,
      currentSheetActivityIdx: 0,
      errors: [],
      meiboErrors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      files: [],
      progress: "0.0",
      isDispProgress: false,
      SheetTypeEnum: Common.SheetTypeEnum,
      ApiTypeEnum: Common.ApiTypeEnum,
    });


    /******************************
     * 答案アップロード済みの受験者リスト
     ******************************/

    const uploadedExaminees = computed((): Examinee[] => {
      return state.examinees.filter((x: Examinee) => x.sheetActivities.length > 0);
    });

    /******************************
     * 答案アップロード未の受験者リスト
     ******************************/

    const unUploadedExaminees = computed((): Examinee[] => {
      return state.examinees.filter((x: Examinee) => x.sheetActivities.length == 0);
    });

    /******************************
     * imgタグのスタイル
     ******************************/

    const imageStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        style["width"] = `${sheetActivitiy.baseWidth * state.scale}px`;
        style["height"] = `${sheetActivitiy.baseHeight * state.scale}px`;
        style["transform"] = `rotate(${sheetActivitiy.angle}deg)`;
        
        // 回転の中心軸設定
        let translateX: string = "";
        let translateY: string = "";
        if(sheetActivitiy.angle == 90){
          translateX = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
        }else if(sheetActivitiy.angle == 180){
          translateX = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
        }else if(sheetActivitiy.angle == 270){
          translateX = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
        }
        style["transform-origin"]  = `${translateX} ${translateY}`;
      }
      
      return style;
    });

    /******************************
     * imgの親divのスタイル
     ******************************/

    const imageWrapStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        if(sheetActivitiy.angle == 0 || sheetActivitiy.angle == 180){
          style["height"] = `${(sheetActivitiy.baseHeight * state.scale) + 30}px`;
        }else{
          style["height"] = `${(sheetActivitiy.baseWidth * state.scale) + 30}px`;
        }
      }
      return style;
    });

    /******************************
     * ドロップエリアの文言
     ******************************/

    const dropAreaText = computed((): string => {
      let text = "";

      if(state.sheet){
        if(context.root.$store.getters.isEntranceOrPractice){
          text = "答案用紙を「受験者一覧の表示順」に並び替えて「模範解答と同じ設定」にてスキャンし、こちらにアップロードしてください。<br>";
        }else if(state.sheet.api_type == state.ApiTypeEnum.Classroom){
          text = "答案用紙を「受験者一覧の表示順」に並び替えて「模範解答と同じ設定」にてスキャンし、こちらにアップロードしてください。<br>";
        }else{
          text = "答案用紙を「出席番号順」に並び替えて「模範解答と同じ設定」にてスキャンし、こちらにアップロードしてください。<br>";
        }
      }
      
      text += "<span style='color:red;'>※JpegファイルやPDFファイルをそのままアップロードすることも可能となりました。（PDFは変換プログラムが作動するため、登録に時間を要します）</span>";
      return text;      
    });

    /******************************
     * 選択答案情報切り替え
     ******************************/

    const changeCurrent = async (examinee: Examinee, sheetActivityIdx: number) => {
      state.currentExaminee = examinee;
      state.currentSheetActivity = state.currentExaminee.sheetActivities[sheetActivityIdx];
      state.currentExamineeIdx = state.examinees.indexOf(examinee);
      state.currentSheetActivityIdx = sheetActivityIdx;
      state.currentSheetActivity.angle = 0;

      // 画像がキャッシュされていない場合はAPIでダウンロード
      if(state.currentSheetActivity.base64Image == null){
        const param: object = {
          sheet_id: state.sheet_id,
          sheet_activity_id: state.currentSheetActivity.id,
          page: state.currentSheetActivityIdx + 1,
          student_no: state.currentExaminee.student_no
        };
        await http.get(`/api/teacher/sheet_upload/download_image?${Common.BuildQuery(param, "")}`).then(response => {
          state.currentSheetActivity.base64Image = response.data.base64_image;
          state.currentSheetActivity.baseWidth = response.data.image_size_hash["width"];
          state.currentSheetActivity.baseHeight = response.data.image_size_hash["height"];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }
    };

    /******************************
     * 拡大ボタン押下
     ******************************/

    const scaleUp = () => {
      state.scale += 0.05;
    };

    /******************************
     * 縮小ボタン押下
     ******************************/

    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    };

    /******************************
     * 画像を表示エリアの横幅に合わせる
     ******************************/

    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        state.scale = imageAreaW / state.currentSheetActivity.baseWidth;
      }
    };

    /******************************
     * 画面サイズに合わせてレイアウト整形
     ******************************/

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop) + "px";
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    /******************************
     * 左回転ボタン押下
     ******************************/

    const rotateLeft = async (): Promise<void> => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.currentSheetActivity.angle - 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    /******************************
     * 右回転ボタン押下
     ******************************/

    const rotateRight = async (): Promise<void> => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.currentSheetActivity.angle + 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    /******************************
     * 回転保存ボタン押下
     ******************************/

    const rotateSave = async (isConfirmMsg: boolean = true, isResutMsg: boolean = true) => {
      
      if(state.currentSheetActivity.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_activity_id: state.currentSheetActivity.id,
        angle: state.currentSheetActivity.angle,
        page: state.currentSheetActivityIdx + 1,
        student_no: state.currentExaminee.student_no
      };

      await http.post(`/api/teacher/sheet_upload/rotate/${state.sheet_id}`, param).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        state.currentSheetActivity.base64Image = response.data.base64_image;
        state.currentSheetActivity.baseWidth = response.data.image_size_hash.width;
        state.currentSheetActivity.baseHeight = response.data.image_size_hash.height;
        state.currentSheetActivity.angle = 0;
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }

        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 一括回転
     ******************************/

    const rotateAll = async (angle: number) => {

      if(!window.confirm(`${state.currentSheetActivity.page}ページ目の一括回転を実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_id: state.sheet_id,
        sheet_activity_id: state.currentSheetActivity.id,
        angle: angle,
        page: state.currentSheetActivityIdx + 1,
      };

      await http.post(`/api/teacher/sheet_upload/rotate_all/${state.sheet_id}`, param).then(response => {

        // キャッシュ済みの答案画像をクリア
        state.examinees.forEach((e: Examinee) => {
          e.sheetActivities.forEach((s: SheetActivity) => {
            s.base64Image = null;
            s.baseWidth = 0;
            s.baseHeight = 0;
          });
        });

        state.currentSheetActivity.base64Image = response.data.base64_image;
        state.currentSheetActivity.baseWidth = response.data.image_size_hash.width;
        state.currentSheetActivity.baseHeight = response.data.image_size_hash.height;
        state.currentSheetActivity.angle = 0;

        alert("処理が完了しました。");
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 名簿保存ボタン押下
     ******************************/

    const saveMeibo = async () => {

      context.root.$store.dispatch("showOverlay");

      state.meiboErrors = [];

      const examinees: object[] = new Array<object>();
      state.examinees.forEach((e: Examinee) => {
        examinees.push({id: e.id, student_no_character: e.student_no_character, student_name: e.student_name, email: e.email});
      });

      await http.post(`/api/teacher/sheet_upload/update_meibo/${state.sheet_id}`, {examinees: examinees}).then(response => {
        alert("保存が完了しました。");

        modalMeiboUploadRef.value.hide();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.meiboErrors = error.response.data.errors;
        }else{
          state.meiboErrors = ["予期せぬ例外が発生しました。"];
        }
      });

      // modalMeiboUploadRef.value.hide();
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 欠席者モーダル表示
     ******************************/

    const showAbsentModal = (file: FileList) => {
      state.files = [].slice.call(file).sort((a: any, b: any) => Common.strCmpLogicalW(a.name, b.name));
      modalSheetUploadRef.value.show();
    };

    /******************************
     * 名簿モーダル表示
     ******************************/

    const showMeiboModal = () => {
      state.meiboErrors = [];
      modalMeiboUploadRef.value.show();
    };

    /******************************
     * アップロードモーダル閉じる
     ******************************/

    const closeSheetUploadModal = () => {
      modalSheetUploadRef.value.hide();
      unUploadedExaminees.value.forEach((x: Examinee) => {
        x.isAbsent = false;
      });
    };

    /******************************
     * 並び順確認ボタン押下
     ******************************/

    const toSortAnswerImage = () => {
      context.root.$router.push(`/teacher_site/sort_answer_image/${state.sheet_id}`).catch(err => {});
    }

    /******************************
     * 答案アップロード
     ******************************/

    const upload = async () => {
      const extension = Common.getFileExtension(state.files[0].name);
      if(extension == "jpg"){
        await uploadJpg();
      }else if(extension == "zip"){
        await uploadZip();
      }else if(extension == "pdf"){
        await uploadPdf();
      }
    }

    /******************************
     * jpg答案アップロード
     ******************************/

    const uploadJpg = async () => {

      // 登録対象の出席番号リスト取得
      const studentNos = unUploadedExaminees.value.filter((x: Examinee) => !x.isAbsent).map((x: Examinee) => x.student_no);

      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      if(studentNos.length * state.sheet.page_count != state.files.length){
        alert("アップロードに必要な画像数（アップロード対象受験者数 × ページ数）と選択した画像数が異なります。");
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      modalSheetUploadRef.value.hide();

      state.isDispProgress = true;
      state.progress = "0.00";

      state.errors = [];
      context.root.$store.dispatch("showOverlay");

      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }

      let fileIdx = 0;
      let completedCount = 0;

      for(let i = 0; i < studentNos.length; i++){
        
        let fd = new FormData();

        for(let j = 0; j < state.sheet.page_count; j++){
          fd.append(`${j}`, state.files[fileIdx]);
          fileIdx++;
        }

        await http.post(`/api/teacher/sheet_upload/upload_jpg/${state.sheet_id}/${studentNos[i]}/${state.sheet.page_count}`, fd, config).then(() => {
          completedCount++;
          state.progress = Number.parseFloat(`${completedCount * 100 / studentNos.length}`).toFixed(2);
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。アップロードに失敗した生徒は再度アップロードを行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          await initialize();
          context.root.$store.dispatch("hideOverlay");
          state.isDispProgress = false;
          return;
        }
      }

      await http.post(`/api/teacher/sheet_upload/upload_jpg_after_process/${state.sheet_id}`)
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0){
        await initialize();
        context.root.$store.dispatch("hideOverlay");
        state.isDispProgress = false;
        return;
      }

      await initialize();

      await resolveAfterMilliSeconds();
      alert("処理が完了しました。");
      state.isDispProgress = false;
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * Zip答案アップロード
     ******************************/

    const uploadZip = async () => {

      modalSheetUploadRef.value.hide();

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }
      
      // 登録対象の出席番号リスト取得
      const studentNos = unUploadedExaminees.value.filter((x: Examinee) => !x.isAbsent).map((x: Examinee) => x.student_no);

      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      let fd = new FormData();
      fd.append("upload[file]", state.files[0]);
      fd.append("student_nos", JSON.stringify(studentNos));

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_upload/upload_zip/${state.sheet_id}`, fd).then(response => {
        
        state.sheet = response.data.sheet;
        const examinees = new Array<Examinee>();
        response.data.sheet.examinees.forEach((x: any) => {
          examinees.push(new Examinee(x, response.data.sheet.sheet_activities));
        });
        state.examinees = examinees;
        if(uploadedExaminees.value.length > 0){
          changeCurrent(uploadedExaminees.value[0], 0);
        }
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      unUploadedExaminees.value.forEach((x: Examinee) => {
        x.isAbsent = false;
      });

      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * PDF答案アップロード
     ******************************/

    const uploadPdf = async () => {

      modalSheetUploadRef.value.hide();

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }
      
      // 登録対象の出席番号リスト取得
      const studentNos = unUploadedExaminees.value.filter((x: Examinee) => !x.isAbsent).map((x: Examinee) => x.student_no);

      if(studentNos.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      let fd = new FormData();
      fd.append("upload[file]", state.files[0]);
      fd.append("student_nos", JSON.stringify(studentNos));

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_upload/upload_pdf/${state.sheet_id}`, fd).then(response => {
        
        state.sheet = response.data.sheet;
        const examinees = new Array<Examinee>();
        response.data.sheet.examinees.forEach((x: any) => {
          examinees.push(new Examinee(x, response.data.sheet.sheet_activities));
        });
        state.examinees = examinees;
        if(uploadedExaminees.value.length > 0){
          changeCurrent(uploadedExaminees.value[0], 0);
        }
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      unUploadedExaminees.value.forEach((x: Examinee) => {
        x.isAbsent = false;
      });

      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * jpgアップロード完了後のインターバル
     ******************************/

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * 答案削除ボタン押下
     ******************************/

    const destroy = async (examinee: Examinee) => {
      if(!window.confirm(`出席番号${examinee.student_no}番の答案を削除します。よろしいですか？`)){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/sheet_upload/destroy/${state.sheet_id}/${examinee.student_no}`).then(response => {
        
        examinee.sheetActivities = new Array<SheetActivity>();
        if(uploadedExaminees.value.length > 0){
          changeCurrent(uploadedExaminees.value[0], 0);
        }

        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 一括削除ボタン押下
     ******************************/

    const destroyAll = async () => {

      if(uploadedExaminees.value.length == 0){
        alert("削除対象が存在しません。");
        return;
      }

      if(!window.confirm("答案を一括削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/sheet_upload/destroy_all/${state.sheet_id}`).then(response => {
        
        state.examinees.forEach(x => {
          x.sheetActivities = new Array<SheetActivity>();
        });

        state.currentExaminee = null;
        state.currentSheetActivity = null;

        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 名簿アップロード
     ******************************/

    const uploadMeibo = async (file: any) => {

      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("名簿をアップロードします。よろしいですか？")){
        return;
      }

      state.meiboErrors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_upload/upload_meibo/${state.sheet_id}`, fd).then(response => {
        state.examinees.forEach(x => {
          const examinee = response.data.examinees.filter((examinee: any) => examinee.student_no == x.student_no);
          if(examinee.length > 0){
            x.student_no_character = examinee[0].student_no_character;
            x.student_name = examinee[0].student_name;
            x.email = examinee[0].email;
          }
        });

        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.meiboErrors = error.response.data.errors;
        }else{
          state.meiboErrors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 名簿テンプレートダウンロード
     ******************************/

    const downloadMeiboTemplate = () => {
      window.location.href = `/api/teacher/sheet_upload/download_meibo_template/${state.sheet_id}`;
    };

    /******************************
     * 切り出しボタン押下
     ******************************/

    const imageCut = async () => {

      if(!window.confirm("切り出しを実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/teacher/sheet_upload/create_cut_job/${state.sheet_id}`).then(response => {
        alert("答案切り出しを開始しました");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /******************************
     * keyUpイベント
     ******************************/

    const keyUp = (e: KeyboardEvent): void => {

      if (e.key == "ArrowDown") {
        e.preventDefault();

        const currentExamineeIdx = uploadedExaminees.value.indexOf(state.currentExaminee)
        if (currentExamineeIdx < (uploadedExaminees.value.length - 1)) {

          changeCurrent(uploadedExaminees.value[currentExamineeIdx + 1], state.currentSheetActivityIdx);
        }
        return;
      }

      if (e.key == "ArrowUp") {
        e.preventDefault();

        const currentExamineeIdx = uploadedExaminees.value.indexOf(state.currentExaminee)
        if (state.currentExamineeIdx > 0) {
          changeCurrent(uploadedExaminees.value[currentExamineeIdx - 1], state.currentSheetActivityIdx);
        }

        return;
      }

      if (e.key == "ArrowLeft") {
        e.preventDefault();

        if (state.currentSheetActivity.page > 1) {
          changeCurrent(state.currentExaminee, state.currentSheetActivityIdx - 1);
        }

        return;
      }
      
      if (e.key == "ArrowRight") {
        e.preventDefault();
        
        if (state.currentSheetActivity.page < state.sheet.page_count) {
          changeCurrent(state.currentExaminee, state.currentSheetActivityIdx + 1);
        }

        return;
      }
    }

    /******************************
     * 初期表示データ取得
     ******************************/

    const initialize = async () => {
      await http.get(`/api/teacher/sheet_upload?sheet_id=${state.sheet_id}`).then(response => {        
        state.sheet = response.data.sheet;
        const examinees = new Array<Examinee>();
        response.data.sheet.examinees.forEach((x: any) => {
          examinees.push(new Examinee(x, response.data.sheet.sheet_activities));
        });
        state.examinees = examinees;
        if(uploadedExaminees.value.length > 0){
          changeCurrent(uploadedExaminees.value[0], 0);
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
    };

    /******************************
     * created
     ******************************/

    const created = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;

      await initialize();

      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keyup", keyUp);

      context.root.$nextTick(() => {
        adjustHeight();
      });

      const tableArea = document.getElementById("table-area");
      const headerLeftArea = document.getElementById("header-left-area");
      headerLeftArea.style.width = `${tableArea.clientWidth}px`;

      context.root.$store.dispatch("hideOverlay");
    };

    // created処理呼び出し
    created();

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      modalSheetUploadRef,
      modalMeiboUploadRef,
      uploadedExaminees,
      unUploadedExaminees,
      imageStyle,
      imageWrapStyle,
      changeCurrent,
      scaleUp,
      scaleDown,
      adjustWidth,
      adjustHeight,
      rotateLeft,
      rotateRight,
      rotateSave,
      rotateAll,
      saveMeibo,
      closeSheetUploadModal,
      showAbsentModal,
      showMeiboModal,
      upload,
      destroyAll,
      destroy,
      uploadMeibo,
      downloadMeiboTemplate,
      imageCut,
      KeyboardEvent,
      keyUp,
      toSortAnswerImage,
      dropAreaText,
     };
  }
})
